import { render, staticRenderFns } from "./AudioStore.vue?vue&type=template&id=5b8fb7e6"
import script from "./AudioStore.vue?vue&type=script&lang=js"
export * from "./AudioStore.vue?vue&type=script&lang=js"
import style0 from "./AudioStore.vue?vue&type=style&index=0&id=5b8fb7e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports